/**
 * Badge styling utilities.
 *
 * Per the OrbitFlow design system, every status / tracker / priority badge
 * uses ONE subtle, theme-driven surface: the primary colour at 0.10 opacity.
 * The badge label carries the distinction — no per-value accent colours.
 */

export interface BadgeStyle {
  variant: 'default' | 'secondary' | 'destructive' | 'outline'
  className: string
}

/** The single, canonical pill style — primary at 0.10 opacity. */
const PRIMARY_PILL: BadgeStyle = {
  variant: 'outline',
  className: 'border-transparent bg-[var(--of-primary-10)] text-[hsl(var(--primary))]',
}

/** Color-coded badge style for tracker types — unified to the theme colour. */
export function getTrackerBadgeStyle(_trackerName: string): BadgeStyle {
  return PRIMARY_PILL
}

/** Color-coded badge style for status — unified to the theme colour. */
export function getStatusBadgeStyle(_statusName: string, _isClosed: boolean): BadgeStyle {
  return PRIMARY_PILL
}

/** Color-coded badge style for priority — unified to the theme colour. */
export function getPriorityBadgeStyle(_priorityId: number, _priorityName?: string): BadgeStyle {
  return PRIMARY_PILL
}
